<!-- Start Contact Page Section -->
<main class="ecb-web-contact-page">

  <!-- Start Contact Banner Section -->
  <section class="ecb-web-contact-banner-section">

    <!-- Start Contact Banner Overlay Section -->
    <div class="ecb-web-contact-banner-overlay"></div>
    <!-- End Contact Banner Overlay Section -->

    <div class="container ecb-web-contact-banner-container hero-inner">
      <div class="row align-items-center">

        <!-- Start Contact Banner Content Section -->
        <div class="col-12 col-lg-6">
          <div class="ecb-web-contact-banner-content">

            <!-- Display the workplace health and safety category label. -->
            <span class="pill">Contact ECB</span>
            <!-- Display the main HSR Training heading. -->

            <h1>Contact Us</h1>

            <div class="ecb-web-voc-title-line"></div>

            <p>
              We're here to help! Get in touch with our friendly team for
              any queries about our courses, locations or corporate
              training solutions.
            </p>

          </div>
        </div>
        <!-- End Contact Banner Content Section -->

      </div>
    </div>

  </section>
  <!-- End Contact Banner Section -->


  <!-- Start Contact Method Section -->
  <section class="ecb-web-contact-method-section">
    <div class="container">

      <!-- Start Contact Method Heading Section -->
      <div class="ecb-web-contact-section-heading">
        <h2>Get in touch <span>with us</span></h2>

        <p>Choose the way that’s most convenient for you.</p>
      </div>
      <!-- End Contact Method Heading Section -->


      <!-- Start Contact Method List Section -->
    
<!-- Start Contact Method List Section -->
<div class="ecb-web-contact-method-grid">

  <article
    class="ecb-web-contact-method-card"
    *ngFor="let method of contactMethods; trackBy: trackById">

    <!-- Icon -->
    <div
      class="ecb-web-contact-method-icon"
      [ngClass]="method.colorClass">

      <i [class]="method.icon"></i>

    </div>

    <!-- Title -->
    <h3>{{ method.title }}</h3>

    <!-- Contact Details -->
    <div class="ecb-web-contact-method-details">

      <div
        class="ecb-web-contact-method-detail"
        *ngFor="let detail of method.details">

        <span class="ecb-web-contact-method-location">
          {{ detail.label }}
        </span>

        <a
          *ngIf="detail.link"
          [href]="detail.link"
          class="ecb-web-contact-method-primary">

          {{ detail.text }}

        </a>

        <p
          *ngIf="!detail.link"
          class="ecb-web-contact-method-primary">

          {{ detail.text }}

        </p>

      </div>

    </div>

    <!-- Additional Information -->
    <p
      *ngIf="method.footer"
      class="ecb-web-contact-method-footer">

      {{ method.footer }}

    </p>

  </article>

</div>
<!-- End Contact Method List Section -->

      <!-- End Contact Method List Section -->

    </div>
  </section>
  <!-- End Contact Method Section -->


  <!-- Start Contact Main Content Section -->
  <section class="ecb-web-contact-main-section" id="course-enquiry">
    <div class="container">
      <div class="row g-4 align-items-stretch">

        <!-- Start Contact Form Column Section -->
        <div class="col-12 col-lg-6">

          <!-- Start Contact Form Panel Section -->
          <article class="ecb-web-contact-form-panel">

            <h2>Send us a message</h2>

            <p>
              Fill out the form below and one of our team members will get
              back to you.
            </p>

            <!-- Start Contact Form Section -->
            <form #contactFormReference="ngForm" (ngSubmit)="submitContactForm()" novalidate>

              <!-- Start Full Name Field Section -->
              <div class="ecb-web-contact-form-field">
                <label for="ecbContactFullName">
                  Full Name
                  <span>*</span>
                </label>

                <input id="ecbContactFullName" type="text" maxlength="250" name="fullName" class="form-control"
                  placeholder="Enter your full name" [(ngModel)]="contactForm.fullName" required>
              </div>
              <!-- End Full Name Field Section -->


              <!-- Start Email Address Field Section -->
              <div class="ecb-web-contact-form-field">
                <label for="ecbContactEmail">
                  Email Address
                  <span>*</span>
                </label>

                <input id="ecbContactEmail" type="email" name="emailAddress" class="form-control"
                  placeholder="Enter your email address" maxlength="100" [(ngModel)]="contactForm.emailAddress" required
                  email>
              </div>
              <!-- End Email Address Field Section -->


              <!-- Start Phone Number Field Section -->
              <div class="ecb-web-contact-form-field">
                <label for="ecbContactPhone">
                  Contact Number
                  <span>*</span>
                </label>

                <!--   <input id="ecbContactPhone" type="tel" name="phoneNumber" class="form-control"
                  placeholder="Enter your phone number" [(ngModel)]="contactForm.phoneNumber" maxlength="15"
                  inputmode="numeric" pattern="[0-9]*"  appPhoneNumberValidation> -->

                <input id="ecbContactPhone" type="tel" name="phoneNumber" class="form-control"
                  placeholder="Enter your phone number" [(ngModel)]="contactForm.phoneNumber" inputmode="numeric"
                   appPhoneNumberValidation>
              </div>
              <!-- End Phone Number Field Section -->


              <!-- Start Subject Field Section -->
              <div class="ecb-web-contact-form-field">
                <label for="ecbContactSubject">
                  Subject
                  <span>*</span>
                </label>

                <select id="ecbContactSubject" name="subject" class="form-select" [(ngModel)]="contactForm.subject"
                  required>
                  <option value="" disabled>
                    Select a subject
                  </option>

                  <option *ngFor="
                      let subject of contactSubjects;
                      trackBy: trackById
                    " [value]="subject.name">
                    {{ subject.name }}
                  </option>
                </select>
              </div>
              <!-- End Subject Field Section -->


              <!-- Start Message Field Section -->
              <div class="ecb-web-contact-form-field">
                <label for="ecbContactMessage">
                  Message
                  <span>*</span>
                </label>

                <textarea id="ecbContactMessage" name="message" class="form-control" rows="6"
                  placeholder="Type your message here..." [(ngModel)]="contactForm.message" required></textarea>
              </div>
              <!-- End Message Field Section -->


              <!-- Start Captcha Display Section -->
              <div class="ecb-web-contact-captcha-box">

                <label class="ecb-web-contact-captcha-check">
                  <input type="checkbox" name="captchaConfirmed" [(ngModel)]="isCaptchaConfirmed">

                  <span class="ecb-web-contact-captcha-custom-check"></span>

                  <span>I'm not a robot</span>
                </label>

                <div class="ecb-web-contact-captcha-brand">
                  <i class="bi bi-arrow-repeat"></i>

                  <strong>reCAPTCHA</strong>

                  <small>Privacy - Terms</small>
                </div>

              </div>
              <!-- End Captcha Display Section -->


              <!-- Start Contact Form Error Message Section -->
              <div class="ecb-web-contact-form-message ecb-web-contact-error-message" *ngIf="isContactError">
                <i class="bi bi-exclamation-circle-fill"></i>

                Please complete all required fields and confirm the
                verification checkbox.
              </div>
              <!-- End Contact Form Error Message Section -->


              <!-- Start Contact Form Success Message Section -->
              <div class="ecb-web-contact-form-message ecb-web-contact-success-message" *ngIf="isContactSuccess">
                <i class="bi bi-check-circle-fill"></i>

                Your message was submitted successfully.
              </div>
              <!-- End Contact Form Success Message Section -->


              <!-- Start Contact Submit Button Section -->
              <button type="submit" class="btn ecb-web-contact-submit-button" [disabled]="
                  contactFormReference.invalid ||
                  !isCaptchaConfirmed ||
                  isContactSending
                ">
                <span>
                  {{
                  isContactSending
                  ? 'Sending...'
                  : 'Submit Message'
                  }}
                </span>

                <i class="bi" [ngClass]="
                    isContactSending
                      ? 'bi-arrow-repeat ecb-web-contact-spinner'
                      : 'bi-send'
                  "></i>
              </button>
              <!-- End Contact Submit Button Section -->

            </form>
            <!-- End Contact Form Section -->

          </article>
          <!-- End Contact Form Panel Section -->

        </div>
        <!-- End Contact Form Column Section -->


        <!-- Start Contact Office Column Section -->
        <div class="col-12 col-lg-6">

          <!-- Start Contact Office Panel Section -->
          <article class="ecb-web-contact-office-panel">

            <h2>Our Offices</h2>

            <!-- Start Contact Office List Section -->
            <div class="ecb-web-contact-office-list">

              <article class="ecb-web-contact-office-item" *ngFor="
                  let office of contactOffices;
                  trackBy: trackById
                ">
                <!-- Start Contact Office Image Section -->
                <img [src]="office.image" [alt]="office.name" class="ecb-web-contact-office-image">
                <!-- End Contact Office Image Section -->

                <!-- Start Contact Office Details Section -->
                <div class="ecb-web-contact-office-details">
                  <h3>{{ office.name }}</h3>

                  <p>{{ office.addressLineOne }}</p>
                  <p>{{ office.addressLineTwo }}</p>

                  <a [href]="'tel:' + office.phone" class="ecb-web-contact-office-phone">
                    {{ office.phone }}
                  </a>

                  <a href="mailto:office.email"  class="ecb-web-contact-office-phone">
                  {{ office.email }}

                  
                  </a>
                  <p class="ecb-web-contact-direction-link">{{ office.openHourse }}</p>
                </div>
                <!-- End Contact Office Details Section -->

              </article>

            </div>
            <!-- End Contact Office List Section -->


            <!-- Start Contact Map Section -->
            <div class="ecb-web-contact-map-wrapper">
              <img src="assets/images/locations/ECB_Map.png" alt="ECB Training office locations map"
                class="ecb-web-contact-map-image">
            </div>
            <!-- End Contact Map Section -->

          </article>
          <!-- End Contact Office Panel Section -->

        </div>
        <!-- End Contact Office Column Section -->

      </div>
    </div>
  </section>
  <!-- End Contact Main Content Section -->


  <!-- Start Contact FAQ Section -->
  <section class="ecb-web-contact-faq-section">
    <div class="container">

      <!-- Start Contact FAQ Panel Section -->
      <div class="ecb-web-contact-faq-panel">

        <!-- Start Contact FAQ Heading Section -->
        <div class="ecb-web-contact-section-heading">
          <h2>Frequently Asked Questions</h2>

          <p>Quick answers to common questions.</p>
        </div>
        <!-- End Contact FAQ Heading Section -->


        <!-- Start Contact FAQ List Section -->
        <div class="ecb-web-contact-faq-list">

          <article class="ecb-web-contact-faq-item" *ngFor="
              let faq of frequentlyAskedQuestions;
              trackBy: trackById
            " [class.ecb-web-contact-faq-open]="isFaqOpen(faq.id)">
            <!-- Start Contact FAQ Question Section -->
            <button type="button" class="ecb-web-contact-faq-question" [attr.aria-expanded]="isFaqOpen(faq.id)"
              (click)="toggleFaq(faq.id)">
              <span>{{ faq.question }}</span>

              <i class="bi" [ngClass]="
                  isFaqOpen(faq.id)
                    ? 'bi-dash'
                    : 'bi-plus'
                "></i>
            </button>
            <!-- End Contact FAQ Question Section -->


            <!-- Start Contact FAQ Answer Section -->
            <div class="ecb-web-contact-faq-answer" *ngIf="isFaqOpen(faq.id)">
              <p>{{ faq.answer }}</p>
            </div>
            <!-- End Contact FAQ Answer Section -->

          </article>

        </div>
        <!-- End Contact FAQ List Section -->


        <!-- Start Contact FAQ Button Section -->
        <!-- <div class="ecb-web-contact-faq-button-wrapper">
          <a href="#" class="btn ecb-web-contact-faq-button">
            View All FAQs
          </a>
        </div> -->
        <!-- End Contact FAQ Button Section -->

      </div>
      <!-- End Contact FAQ Panel Section -->

    </div>
  </section>
  <!-- End Contact FAQ Section -->

</main>
<!-- End Contact Page Section -->